export default __webpack_public_path__ + "static/media/logo.a86e7b30.png";